import React from 'react';
import TextField from '@material-ui/core/TextField';
// import ListboxComponent from '../ListboxComponent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from 'prop-types';
import { noop } from '../propTypes';
import UserIcon from '../../icons/userIcon.svg';
import './styles.scss';

function AutoCompleteSingle({
    title,
    options,
    placeholder,
    bootstrapIcon,
    onSelect,
    disabled,
    defaultValue,
    id,
    isLoading,
    getOptionLabel,
    hasIcon,
    style,
    renderOption,
    value,
    noOptionsText,
    onInputChange,
    getOptionSelected,
}) {
    const stylesIcon = { justifyContent: 'center' };
    return (
        <div className="customInput">
            <h3 className="titleStyle2">{title}</h3>
            <div className="input-group">
                <div className="input-group-prepend">
                    <span className="input-group-text" style={stylesIcon}>
                        {hasIcon ? (
                            <img src={bootstrapIcon} />
                        ) : (
                            <i className={bootstrapIcon}></i>
                        )}
                    </span>
                    <Autocomplete
                        id={id}
                        value={value}
                        options={options}
                        defaultValue={defaultValue}
                        getOptionLabel={getOptionLabel}
                        getOptionSelected={getOptionSelected}
                        disabled={disabled}
                        onInputChange={onInputChange}
                        onChange={(event, selected) => {
                            Object.keys(event); //this will give you the selected value dictionary (source)
                            onSelect(selected); //this will give you the selected value dictionary (source)
                        }}
                        noOptionsText={noOptionsText}
                        style={style}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder={placeholder}
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {isLoading ? (
                                                <CircularProgress
                                                    color="inherit"
                                                    size={20}
                                                />
                                            ) : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                        renderOption={renderOption}
                    />
                </div>
            </div>
        </div>
    );
}

AutoCompleteSingle.propTypes = {
    isLoading: PropTypes.bool,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    bootstrapIcon: PropTypes.string,
    title: PropTypes.string,
    onSelect: PropTypes.func,
    id: PropTypes.string,
    rightBtnText: PropTypes.string,
    hasIcon: PropTypes.bool,
    showRightBtn: PropTypes.bool,
    onRightBtnClick: PropTypes.func,
    defaultValue: PropTypes.object,
    disabled: PropTypes.bool,
    getOptionLabel: PropTypes.func.isRequired,
    getOptionSelected: PropTypes.func,
    style: PropTypes.object,
    renderOption: PropTypes.func,
    value: PropTypes.object,
    noOptionsText: PropTypes.string,
    onInputChange: PropTypes.func,
};

AutoCompleteSingle.defaultProps = {
    title: ' ',
    isLoading: false,
    value: null,
    placeholder: 'Favorites',
    hasIcon: true,
    bootstrapIcon: UserIcon,
    onSelect: noop,
    id: '12',
    defaultValue: null,
    rightBtnText: 'Compare',
    showRightBtn: false,
    onRightBtnClick: noop,
    disabled: false,
    getOptionLabel: (option) => option.name,
    getOptionSelected: (option, value) => option.id === value.id,
    renderOption: (option) => `${option.id} | ${option.name}`,
    noOptionsText: '',
    onInputChange: noop,
};

export default AutoCompleteSingle;
